// components/Pagination.js
import React, { Suspense } from "react";

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleClick = (pageNumber) => {
    onPageChange(pageNumber);
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div
        className={
          totalItems < 10
            ? "mt-56 flex justify-center items-center max-md:flex-wrap max-md:gap-2"
            : " mt-10 flex justify-center items-center max-md:flex-wrap max-md:gap-2"
        }
      >
        <button
          className={`mx-1 px-3 py-1 ${
            currentPage === 1
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-main text-white"
          }`}
          onClick={() => {
            handleClick(currentPage - 1);
            if (typeof window !== "undefined") {
              window.scrollTo(0, 0);
            }
          }}
          disabled={currentPage === 1}
        >
          Önceki
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            className={`mx-1 px-3 py-1 ${
              currentPage === index + 1 ? "bg-main text-white" : "bg-gray-200"
            }`}
            onClick={() => {
              handleClick(index + 1);
              if (typeof window !== "undefined") {
                window.scrollTo(0, 0);
              }
            }}
          >
            {index + 1}
          </button>
        ))}
        <button
          className={`mx-1 px-3 py-1 ${
            currentPage === totalPages
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-main text-white"
          }`}
          onClick={() => {
            handleClick(currentPage + 1);
            if (typeof window !== "undefined") {
              window.scrollTo(0, 0);
            }
          }}
          disabled={currentPage === totalPages}
        >
          Sonraki
        </button>
      </div>
    </Suspense>
  );
};

export default Pagination;
